import { useContext } from 'react';

import { getUtm, UtmParams } from '@utils/utm-storage';
import { getGaClientId } from '@utils/google-analytics';

import { GoogleOptimizeContext } from '@modules/providers/google-optimize';

import { useQueryParamsAppender } from './use-query-params-appender';

export const useTypeformParamsAppender = (deps: any[]) => {
  // UTM params
  const utm = getUtm() || {};
  const formattedUtm = Object.keys(utm).reduce<Record<string, any>>(
    (acc, curr) => {
      acc[`utm_${curr}`] = utm[curr as keyof UtmParams];
      return acc;
    },
    {},
  );

  // clientId
  const clientId = getGaClientId();

  // optimizeId
  const { optimizeVariants } = useContext(GoogleOptimizeContext);
  const stringifiedOptimizeVariants = Object.keys(optimizeVariants)
    .map((variant) => `${variant}:${optimizeVariants[variant]}`)
    .join(',');

  useQueryParamsAppender(
    /^(https?:\/\/)?(www\.)?(reascz\.)?typeform\.com\//,
    {
      ...formattedUtm,
      client_id: clientId,
      optimize_variants: stringifiedOptimizeVariants,
    },
    [deps],
  );
};
